import { useSEOMeta } from '@/lib/seo'
import type { SEOMeta } from '@/lib/seo'

interface SEOHeadProps {
  meta?: SEOMeta
}

export function SEOHead({ meta }: SEOHeadProps) {
  // This component triggers side effects on mount — no visual output
  useSEOMeta(meta || {})
  return null
}

export default SEOHead
